import { authedFetch } from './api'

/**
 * Trimite raspunsurile la onboarding catre backend-ul propriu,
 * care apeleaza Claude server-side (cheia NU mai e expusa in browser).
 * Trimite tokenul Supabase ca backend-ul sa accepte doar useri autentificati.
 */
export async function analyzeOnboarding(answers) {
  try {
    const response = await authedFetch('/analyze-onboarding', {
      method: 'POST',
      body: JSON.stringify({ answers }),
    })

    if (!response.ok) {
      console.error('AI API error:', response.status)
      return getDefaultProfile()
    }

    const data = await response.json()
    if (!data?.profile) {
      console.error('AI empty response:', data)
      return getDefaultProfile()
    }
    return data.profile
  } catch (e) {
    console.error('AI request failed:', e)
    return getDefaultProfile()
  }
}

export function getDefaultProfile() {
  return {
    gravitate: { scor: 50, nivel: 'mediu', descriere: 'Situatie moderata, dar cu potential de imbunatatire.' },
    profil_financiar: {
      venit_lunar: 3000,
      buget_zilnic_total: 100,
      buget_zilnic_joc: 30,
      cheltuieli: {
        mancare_zilnic: 25,
        utilitati_zilnic: 10,
        rata_zilnic: 0,
        copii_zilnic: 0,
        transport_zilnic: 8,
        alte_zilnic: 27,
      }
    },
    slot_config: {
      miza_per_spin: 2,
      probabilitate_castig: 0.08,
      multiplicator_castig_min: 0.60,
      multiplicator_castig_max: 0.90,
      spinuri_disponibile_azi: 15,
      buget_sesiune_azi: 30,
    },
    mesaje_personalizate: {
      pierdere_mancare: 'Tocmai ai pierdut banii de mancare pentru azi.',
      pierdere_utilitati: 'Aceasta suma acoperea o parte din factura de curent.',
      pierdere_rata: null,
      pierdere_copii: null,
      pierdere_generic: 'Inca o pierdere. Algoritmul nu doarme niciodata.',
      castig_avertisment: 'Ai castigat, dar mai putin decat ai bagat. Casa castiga mereu.',
      datorie_prieten: 'Bugetul tau s-a terminat. Trebuie sa suni pe cineva.',
    },
    datorii_config: {
      prag_datorie: 30,
      suma_datorie_initiala: 300,
      prieteni: [
        { nume: 'Andrei', suma_disponibila: 200, mesaj: 'Bro, iar? Bine, iti dau dar e ultima data...' },
        { nume: 'Mama', suma_disponibila: 150, mesaj: 'Fiule, ce se intampla cu tine? Iti dau dar vorbim.' },
        { nume: 'Mihai', suma_disponibila: 100, mesaj: 'Nu prea am nici eu, dar iti dau 100.' },
      ]
    },
    context: {
      are_copii: false,
      are_rata: false,
      are_partener: false,
      a_imprumutat_inainte: false,
      ani_de_joc: 1,
      a_incercat_sa_se_opreasca: false,
    }
  }
}
